import React from 'react';
import { CrudPage } from '@restavo/crud';
import { useStorefrontMessagesPage } from 'src/features/storefrontMessages';

const StorefrontMessages = React.memo(() => {
  const { page } = useStorefrontMessagesPage();
  // A message is written by a visitor and is never deleted, so both writes are off. `canUpdate`
  // stays at its default: changing the status is the one thing this screen exists to do.
  return <CrudPage {...page} canCreate={false} canDelete={false} />;
});
StorefrontMessages.displayName = 'StorefrontMessages';

export default StorefrontMessages;
